import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Research`}</h2>
    <p>{`My research interests lie in the area of Groups, Rings, Lie and Hopf Algebras. The results obtained by me (often in cooperation with my colleagues) deal with the following matters:`}</p>
    <ul>
      <li parentName="ul">{`Identical relations and varieties of Lie and associative algebras and superalgebras,`}</li>
      <li parentName="ul">{`Enveloping algebras and representations of Lie algebras and superalgebras,`}</li>
      <li parentName="ul">{`Automorphism groups of certain Lie algebras,`}</li>
      <li parentName="ul">{`Structure and representations of locally finite Lie algebras,`}</li>
      <li parentName="ul">{`Algebras with actions and coactions of Hopf algebras,`}</li>
      <li parentName="ul">{`Graded algebras and applications.`}</li>
    </ul>
    <hr></hr>
    <p>{`I have written some monographs and textbooks (#3 below with my former students):`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Doe, J. A. Lectures on Lie algebras. Lectures given at Humboldt University, Berlin and Lomonosov University, Moscow. Studien zur Algebra und ihre Anwendungen `}{`[Studies in Algebra and its Applications]`}{`, 4. Akademie-Verlag, Berlin, 1978. viii+126 pp.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Doe, John. A. Identical relations in Lie algebras. Translated from the Russian by Bakhturin. VNU Science Press, b.v., Utrecht, 1987. x+309 pp. ISBN: 90-6764-052-2`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Doe, John A.; John, Pablo A.; Petro, Viktor M.; Mark, William V. Infinite-dimensional Lie superalgebras. de Gruyter Expositions in Mathematics, 7. Walter de Gruyter & Co., Berlin, 1992. x+250 pp. ISBN: 3-11-012974-4`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Doe, John Basic structures of modern algebra. Mathematics and its Applications, 265. Kluwer Academic Publishers Group, Dordrecht, 1993. x+419 pp. ISBN: 0-7923-2459-5`}</p>
      </li>
    </ul>
    <hr></hr>
    <p>{`The most recent published papers include:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Doe, John.; Pablo, Helmut. Locally finite-dimensional simple Lie algebras. Mat. Sb. 185 (1994), no. 2, 3-32.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Doe, John.; Pablo, Georgia M.. Highest weight modules for locally finite Lie algebras. Modular interfaces...AMS/IP Studies in Math. 4 (1997), 1-31.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Doe, John.; Zaico M. V. Identities of graded algebras. J. Algebra 205 (1998), no. 1, 1-12`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Doe, John.; Linco, Vitaly. Identities of algebras with actions of Hopf algebras. J. Algebra, 202 (1998), 634 - 654.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Doe, John; Gondo, Davida; Montgomery, Susan. Bicharacters, twistings, and Scheunert's theorem for Hopf algebras. J. Algebra 236 (2001), no. 1, 246-276.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Doe, John. A.; Pablo, S. K.; Mark, M. V. Group gradings on associative algebras. J. Algebra, 241 (2001), 677-698.`}</p>
      </li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      